import { useLocation, useRoutes } from 'react-router-dom'
import router from 'src/router'

import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'

import { CssBaseline } from '@mui/material'
import ThemeProvider from './theme/ThemeProvider'
import { useJwtQueryParams } from './utils/hooks/useJwtQueryParams'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify'

function App() {
	const content = useRoutes(router)
	const { search } = useLocation()
	useJwtQueryParams(search)

	return (
		<ThemeProvider>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<CssBaseline />
				{content}
			</LocalizationProvider>
			<ToastContainer closeOnClick closeButton={false} limit={1} hideProgressBar />,
		</ThemeProvider>
	);
}
export default App;
